const BRANDS = {
  STARBUCKS: { id: "STARBUCKS" },
  VIPS: { id: "VIPS" },
  BURGERKING: { id: "BURGERKING" },
  DOMINOS: { id: "DOMINOS" },
  ITALIANNIS: { id: "ITALIANNIS" },
  CHILIS: { id: "CHILIS" },
  PFCHANGS: { id: "PFCHANGS" },
  CHEESECAKE: { id: "CHEESECAKE" },
  CHIPOTLE: { id: "CHIPOTLE" },
  SAZONE: { id: "SAZONE" },
  PORTON: { id: "PORTON" },
};

export default BRANDS;

export const BRAND_CONFIG = {
  STARBUCKS: {
    WERKS: "QSBX",
    LGORT: "B573",
  },
  CHILIS: {
    WERKS: "QCHI",
    LGORT: "H063",
  },
};
